var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-base64-icon',{staticClass:"svg-icon",attrs:{"base64Icon":_vm.iconSrc,"width":_vm.width,"height":_vm.height}})}
var staticRenderFns = []

export { render, staticRenderFns }